import { render, staticRenderFns } from "./SlideBase.vue?vue&type=template&id=3bc9fe2e"
import script from "./SlideBase.vue?vue&type=script&lang=js"
export * from "./SlideBase.vue?vue&type=script&lang=js"
import style0 from "./SlideBase.vue?vue&type=style&index=0&id=3bc9fe2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports